import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledRegisteredAppointments = styled(StyledFlex)`
   max-width: 100%;
   padding: 22px 0;
`;
StyledRegisteredAppointments.displayName = 'StyledRegisteredAppointments';
